<template>
    <b-tab title="Invoices" :active="isActive"><p>Invoice Tab</p></b-tab>
</template>
<script>
import { BTab } from 'bootstrap-vue'

export default {
    name: "FdbTabInvoices",
    components: {
        BTab
    },
    props: {
        isActive: {
            type: Boolean,
            default: false
        }
    }
}
</script>
